import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    PATHWAYS: gql`
      query Pathways($userkey: Int!) {
        pathways(userkey: $userkey) {
          type
          pathkey
          title
          description
          wizardpath
          certificateStatus
          displaySettings {
            background {
              type
              value
            }
            icon {
              type
              value
            }
            behaviourFlags
          }
        }
      }
    `,
    COURSE: gql`
      query Course($coursekey: String!) {
        course(coursekey: $coursekey) {
          type
          pathkey
          title
          description
          wizardpath
          displaySettings {
            background {
              type
              value
            }
            icon {
              type
              value
            }
            behaviourFlags
          }
        }
      }
    `,
    PATHWAY_CONTENT: gql`
      query PathwayContent(
        $userkey: Int!
        $pathkey: String!
        $type: ContentType!
      ) {
        pathwayContent(userkey: $userkey, pathkey: $pathkey, type: $type) {
          type
          pathkey
          lessons {
            pathkey
            cert
            lessonkey
            lessonVersion
            contentType
            type
            wizard
            zones {
              zonekey
              title
              isDistributionZone
            }
            title
            results {
              title
              resultkey
              status
              modified
            }
            attempts {
              userkey
              modulekey
              layer
              moduleversion
              state
              status
              created
              modified
              completed
              expires
            }
            behaviorSettings {
              showAllVersions
              lockCompletedLessons
              lockCourse
              editAllVersions
              completionType
              completionThreshold
              multipleAttempts
            }
            displaySettings {
              background {
                type
                value
              }
            }
          }
          recentLessons {
            pathkey
            cert
            lessonkey
            lessonVersion
            contentType
            type
            wizard
            zones {
              zonekey
              title
              isDistributionZone
            }
            title
            results {
              title
              resultkey
              status
              modified
            }
            attempts {
              userkey
              modulekey
              layer
              moduleversion
              state
              status
              created
              modified
              completed
              expires
            }
            behaviorSettings {
              showAllVersions
              lockCompletedLessons
              lockCourse
              editAllVersions
              completionType
              completionThreshold
              multipleAttempts
            }
            displaySettings {
              background {
                type
                value
              }
            }
          }
        }
      }
    `,
    COURSE_PROGRESS: gql`
      query CourseProgress(
        $type: ContentType!
        $userkey: Int!
        $pathkey: String!
      ) {
        courseProgress(type: $type, userkey: $userkey, pathkey: $pathkey) {
          completed
          started
          notStarted
          status
        }
      }
    `,
    GET_LESSON_LAUNCH_URL: gql`
      query getLessonLaunchUrl(
        $username: String!
        $zonekey: Int!
        $pathkey: String!
        $lessonkey: String!
        $resultkey: Int
        $targetOrigin: String!
      ) {
        getLessonLaunchUrl(
          username: $username
          zonekey: $zonekey
          pathkey: $pathkey
          lessonkey: $lessonkey
          resultkey: $resultkey
          targetOrigin: $targetOrigin
        )
      }
    `,
    XAPI_LAUNCH_URL: gql`
      query xApiLaunchUrl(
        $lessonkey: Int!
        $lessonVersion: Int!
        $preview: Boolean!
        $status: ProgressStatusCode
        $layer: Int
      ) {
        xApiLaunchUrl(
          lessonkey: $lessonkey
          lessonVersion: $lessonVersion
          preview: $preview
          status: $status
          layer: $layer
        )
      }
    `,
    USER_MODULE_PORTFOLIO: gql`
      query UserModulePortfolio($userkey: Int!, $modulekey: Int!) {
        userModulePortfolio(userkey: $userkey, modulekey: $modulekey) {
          module {
            modulekey
            coursekey
            title
            created
            archived
            assets {
              certificate {
                expiry
                media
                lifetime
                expires
              }
            }
          }
          portfolio {
            userkey
            modulekey
            layer
            moduleversion
            state
            created
            modified
            completed
            expires
          }
        }
      }
    `,
    GET_MODULE: gql`
      query GetModule($modulekey: Int!) {
        getModule(modulekey: $modulekey) {
          coursekey
        }
      }
    `,
    GET_USER_CERTIFICATES: gql`
      query GetUserCertificates($userkey: Int!) {
        getUserCertificates(userkey: $userkey) {
          courses {
            coursekey
            courseTitle
            certStatus
            completed
            assets {
              expiry
              media
              lifetime
              expires
            }
          }
          lessons {
            coursekey
            lessonkey
            lessonTitle
            completed
            certStatus
            assets {
              expiry
              media
              lifetime
              expires
            }
          }
        }
      }
    `
  },
  Mutation: {
    DELETE_RESULT: gql`
      mutation DeleteResult($resultkey: String!) {
        deleteResult(resultkey: $resultkey)
      }
    `,
    UPDATE_RESULT_TITLE: gql`
      mutation UpdateResultTitle($resultkey: String!, $title: String!) {
        updateResultTitle(resultkey: $resultkey, title: $title) {
          title
          resultkey
          status
          modified
        }
      }
    `,
    SAVE_PAYMENT_HISTORY: gql`
      mutation SavePaymentHistory($groupkey: Int!, $input: PaymentEntry!) {
        savePaymentHistory(groupkey: $groupkey, input: $input) {
          userkey
          groupkey
          amount
          currency
          status
        }
      }
    `,
    UPSERT_LESSON_RESULT: gql`
      mutation UpsertLessonResult(
        $userkey: Int!
        $modulekey: Int!
        $moduleVersion: Int!
        $layer: Int
        $state: Int
      ) {
        upsertLessonResult(
          userkey: $userkey
          modulekey: $modulekey
          moduleVersion: $moduleVersion
          layer: $layer
          state: $state
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
        }
      }
    `,
    DELETE_LESSON_RESULT: gql`
      mutation DeleteLessonResult(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
      ) {
        deleteLessonResult(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
        )
      }
    `,
    UPSERT_ANSWER: gql`
      mutation UpsertAnswer(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $componentkey: Int!
        $answer: String!
        $points: Int
      ) {
        upsertAnswer(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          componentkey: $componentkey
          answer: $answer
          points: $points
        ) {
          userkey
          modulekey
          layer
          componentkey
          answer
          created
          modified
          mark
        }
      }
    `,
    MIGRATE_PORTFOLIO: gql`
      mutation MigratePortfolio(
        $userkey: Int!
        $coursekey: Int!
        $modulekey: Int!
        $lessonVersion: Int!
        $layer: Int!
      ) {
        migratePortfolio(
          userkey: $userkey
          coursekey: $coursekey
          modulekey: $modulekey
          lessonVersion: $lessonVersion
          layer: $layer
        ) {
          userkey
          modulekey
          layer
          moduleversion
          state
          created
          modified
          completed
          expires
        }
      }
    `,
    DELETE_ANSWER: gql`
      mutation DeleteAnswer(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $componentkey: Int!
      ) {
        deleteAnswer(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          componentkey: $componentkey
        )
      }
    `,
    FINISH_LESSON_SESSION: gql`
      mutation FinishLessonSession(
        $lessonType: LessonType!
        $lessonkey: Int!
        $lessonVersion: Int!
        $layer: Int!
        $completed: Boolean!
      ) {
        finishLessonSession(
          lessonType: $lessonType
          lessonkey: $lessonkey
          lessonVersion: $lessonVersion
          layer: $layer
          completed: $completed
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
          created
          modified
          completed
          expires
          status
        }
      }
    `,
    FINALIZE_QUIZ_LESSON: gql`
      mutation FinalizeQuizLesson(
        $userkey: Int!
        $modulekey: Int!
        $moduleVersion: Int!
        $layer: Int!
      ) {
        finalizeQuizLesson(
          userkey: $userkey
          modulekey: $modulekey
          moduleVersion: $moduleVersion
          layer: $layer
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
        }
      }
    `,
    COMPLETE_LESSON_RESULT: gql`
      mutation CompleteLessonResult(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
      ) {
        completeLessonResult(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
          created
          modified
          completed
          expires
        }
      }
    `,
    SUBMIT_LESSON: gql`
      mutation SubmitLesson(
        $modulekey: Int!
        $moduleVersion: Int!
        $layer: Int!
        $retry: Boolean!
      ) {
        submitLesson(
          modulekey: $modulekey
          moduleVersion: $moduleVersion
          layer: $layer
          retry: $retry
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
          created
          modified
          completed
          expires
        }
      }
    `,
    UNSUBMIT_LESSON: gql`
      mutation UnsubmitLesson(
        $modulekey: Int!
        $moduleVersion: Int!
        $layer: Int!
      ) {
        unsubmitLesson(
          modulekey: $modulekey
          moduleVersion: $moduleVersion
          layer: $layer
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
          created
          modified
          completed
          expires
        }
      }
    `,
    UPDATE_SCROLL_POSITION: gql`
      mutation UpdateScrollPosition(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $componentkey: Int!
      ) {
        updateScrollPosition(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          componentkey: $componentkey
        ) {
          position
        }
      }
    `
  }
};

export default GraphQL;
